module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_29.8364656a.png";